import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=5db3f656&scoped=true"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"
import style0 from "./UsersView.vue?vue&type=style&index=0&id=5db3f656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db3f656",
  null
  
)

export default component.exports